import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"
import Alert from "react-s-alert";
import '../../../local_node_modules/react-select/dist/react-select.css';
import {deepCopyObject} from "../../../helper/helper";
import {VirtualHost} from "../../../constants"



class InvoiceType extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.onChange = this.onChange.bind(this);
		this.filterInvoiceTypeCodes = this.filterInvoiceTypeCodes.bind(this);
		this.filterScenarioOptions = this.filterScenarioOptions.bind(this);
	}

	componentDidMount() {
		let {invoiceTypeCode, profileId, accountingCost} = this.props;
		this.setState({invoiceTypeCode, profileId, accountingCost});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const propsChange =  this.props !== prevProps;
		if(propsChange){
			let {invoiceTypeCode, profileId, accountingCost} = this.props;
			this.setState({invoiceTypeCode, profileId, accountingCost});
		}

	}

	filterScenarioOptions(){
		let self = this;
		if(self.state.profileId === "EBELGE"){
			return [{
				value:"EBELGE",
				label:"EBELGE"
			}]
		}

		let profileIds = (self.state.profileId === "EARSIVFATURA") ?
			self.props.profileIds.filter(item => item.shortName === "EARSIVFATURA") :
			self.props.profileIds.filter(item => item.shortName !== "EARSIVFATURA");

		return profileIds.map(profileId => ({
			value: profileId.shortName,
			label: profileId.longName
		}));

	}

    setAccountingCostByDomain(){
		let value;
        if(VirtualHost.conf.resourcePrefix === "togb")
			value = "SAGLIK_OPT";
		else
			value = "SAGLIK_ECZ";
		return value;
	}

	onChange(e) {
		let data = deepCopyObject(this.state);
		let name = e.target.name;
		let value = e.target.value;
		if (name === "profileId") {
			if (value !== "TEMELFATURA" && data.invoiceTypeCode === "SGK") {
				value = "TEMELFATURA";
				Alert.warning("Fatura Türü SGK iken Senaryo türü TEMELFATURA olmalıdır.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			} else {
				if (value === "YOLCUBERABERFATURA" || value === "IHRACAT") {
					data["invoiceTypeCode"] = "ISTISNA";
				}
			}
		}
		if (name === "invoiceTypeCode") {
			if (value === "SGK") {
				if (data.profileId !== "TEMELFATURA") {
					Alert.warning("Fatura Türü SGK iken Senaryo türü TEMELFATURA olmalıdır.", {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
				}
				data.profileId = "TEMELFATURA";
				data.accountingCost = this.setAccountingCostByDomain();
			} else {
				data.accountingCost = null;
			}
		}

		if(this.props.profileId==="EBELGE" && name==="invoiceTypeCode"){
			data["documentTypeCode"] = value;
		}

		data[name] = value;
		let invoiceTypeCodes = this.filterInvoiceTypeCodes(data.profileId);
		let invoiceTypeCheck = false;
		for (let i = 0; i < invoiceTypeCodes.length; i++) {
			if (data.invoiceTypeCode === invoiceTypeCodes[i].shortName) {
				invoiceTypeCheck = true;
				break;
			}
		}
		if (!invoiceTypeCheck)
			data.invoiceTypeCode = invoiceTypeCodes[0].shortName;

		this.setState({
			invoiceTypeCode: data.invoiceTypeCode,
			profileId: data.profileId,
			accountingCost: data.accountingCost
		});
		this.props.listener(data);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.manual || nextProps.isUpdateScenario) {
			this.setState({
				invoiceTypeCode: nextProps.invoiceTypeCode,
				profileId: nextProps.profileId,
				accountingCost: nextProps.accountingCost
            }, () =>{
				this.props.isManual(false);
				this.props.updateScenario(false);
				this.props.listener(this.state);
			});
		}
	}

	filterInvoiceTypeCodes(profileId) {
		let profileIds;
		let invoiceTypeCodes = deepCopyObject(this.props.invoiceTypeCodes);

		if (profileId !== undefined)
			profileIds = profileId;
		else
			profileIds = this.state.profileId;


		if (profileIds === "YOLCUBERABERFATURA" || profileIds === "IHRACAT") {
			invoiceTypeCodes = [{shortName: "ISTISNA", longName: "İstisna"}];
		} else if (profileIds === "EARSIVFATURA" || profileIds === "TICARIFATURA") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["SGK"].includes(typeCode.shortName));

		} else if (profileIds === "TEMELFATURA") {
			let index = invoiceTypeCodes.map(function (e) {
				return e.shortName;
			}).indexOf("SGK");
			if (index === -1)
				invoiceTypeCodes.push({shortName: "SGK", longName: "SGK"});
		} else if (profileIds === "HKS") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => ["SATIS", "KOMISYONCU"].includes(typeCode.shortName));
		} else if (profileIds === "ENERJI") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => ["SARJ", "SARJANLIK"].includes(typeCode.shortName));
		}

		if (profileIds !== "HKS") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["KOMISYONCU"].includes(typeCode.shortName));
		}

		if (profileIds !== "ENERJI" && profileIds !== "EARSIVFATURA") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["SARJ", "SARJANLIK"].includes(typeCode.shortName));
		}

		if (profileIds === "ILAC_TIBBICIHAZ") {
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["KOMISYONCU", "OZELMATRAH"
				,"SGK"
				,"HKSSATIS"
				,"HKSKOMISYONCU"
				,"KOMISYONCU"
				,"KONAKLAMAVERGISI"
				,"SARJ"
				,"SARJANLIK"
			].includes(typeCode.shortName));
		}

		if (profileIds !== "EARSIVFATURA")
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["HKSSATIS", "HKSKOMISYONCU", "TEKNOLOJIDESTEK"].includes(typeCode.shortName));
		else
			invoiceTypeCodes = invoiceTypeCodes.filter(typeCode => !["KOMISYONCU"].includes(typeCode.shortName));

		return invoiceTypeCodes;
	}

	render() {
		let invoiceTypeCodes = this.filterInvoiceTypeCodes();
		return (
            <div>
				{"EBELGE" !== this.props.profileId &&
				<div className="row">
					<label className="col-sm-12 col-lg-6 col-form-label">Senaryo Türü *</label>
					<div className="col-sm-12 col-lg-6">
						<div className="form-group">
							<Select
								name="profileId"
								value={this.state.profileId}
								clearable={false}
								placeholder="Seçiniz..."
								noResultsText="Kayıt bulunamadı."
								onChange={(e) => e && this.onChange({target: {name: "profileId", value: e.value}})}
								options={this.filterScenarioOptions()}
							/>
						</div>
					</div>
				</div>}
                <div className="row ">
                    <label className="col-sm-12 col-lg-6 col-form-label">Fatura Türü *</label>
                    <div className="col-sm-12 col-lg-6">
                        <div className="form-group">
						<Select
								name="invoiceTypeCode"
								value={this.state.invoiceTypeCode}
								clearable={false}
								onChange={(e) => e && this.onChange({
									target: {
										name: "invoiceTypeCode",
										value: e.value
									}
								})}
								options={invoiceTypeCodes.map(invoiceTypeCode => ({
									value: invoiceTypeCode.shortName,
									label: invoiceTypeCode.longName
								}))}
						/>
                        </div>
                    </div>
                </div>
					{this.state.invoiceTypeCode === "SGK" &&
                <div className="row">
                    <label className="col-sm-12  col-lg-6 col-form-label">İlave Fatura Türü *</label>
                    <div className="col-sm-12 col-lg-6">
                        <div className="form-group">
						<Select
								name="accountingCost"
								value={this.state.accountingCost}
								clearable={false}
								placeholder="Seçiniz"
                                onChange={(e) => e && this.onChange({target: {name: "accountingCost", value: e.value}})}
								options={this.props.accountingCosts.map(accountingCost => ({
									value: accountingCost.shortName,
									label: accountingCost.longName
								}))}
						/>
                        </div>
                    </div>
                </div>
                }
				</div>
		);
	}
}

export default InvoiceType;